export default class SidebarFilter {
  constructor(node) {
    this.element = node;

    this.filtersWrapper = this.element.querySelector(".js-sidebar-filters");
    this.filterElements = this.filtersWrapper.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    this.resultsElement = this.element.querySelector(".js-sidebar-filter-results");

    this.url = new URL(this.element.dataset.url, window.location.origin);
    this.filterValues = {};

    this.initialize();
  }

  initialize() {
    this.initializeFromSearchParams().then(() => {
      this.filterElements.forEach((filterElement) => {
        filterElement.addEventListener("change", () => {
          this.updateUrl();
        });
      });
    });
  }

  async initializeFromSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.forEach(function (value, key) {
      const values = value.split(",");

      values.forEach(function (val) {
        const filterElement = document.querySelector(`input[name="${key}"][value="${val}"]`);
        if (filterElement) {
          const collapseElement = filterElement.closest(".collapse");
          filterElement.checked = true;

          if (collapseElement) {
            collapseElement.classList.add("show");
          }

          filterElement.dispatchEvent(new Event("change"));
        }
      });
    });
  }

  updateUrl() {
    const filterValues = {};
    const currentUrl = new URL(window.location);
    const searchParams = new URLSearchParams(currentUrl.search);

    this.filterElements.forEach((filterElement) => {
      if (filterElement.checked) {
        if (!filterValues[filterElement.name]) {
          filterValues[filterElement.name] = [];
        }
        filterValues[filterElement.name].push(filterElement.value);
      }
    });

    for (let filterName in filterValues) {
      searchParams.set(filterName, filterValues[filterName].join(","));
    }

    this.filterElements.forEach((filterElement) => {
      if (!filterValues[filterElement.name]) {
        searchParams.delete(filterElement.name);
      }
    });

    const newUrl = currentUrl.pathname + "?" + searchParams.toString();
    window.history.pushState({}, "", newUrl);

    clearTimeout(this.filterTimeOut);
    this.filterTimeOut = setTimeout(() => {
      this.url.search = searchParams.toString();

      this.fetchContent();
      window.dispatchEvent(
        new CustomEvent("updated-params", {
          detail: {
            searchParams,
          },
        })
      );
    }, 500);
  }

  fetchContent() {
    this.resultsElement.classList.add("is-loading");

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong on api server!");
      })
      .then((data) => {
        this.resultsElement.innerHTML = data.html;
      })
      .catch((e) => {
        console.error(e);
        sendAppsignalError(e, "SidebarFilter", {
          response: this.response,
        });
      })
      .finally(() => {
        this.resultsElement.classList.remove("is-loading");
      });
  }
}
